module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 1);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = require("prosemirror-state");

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _footnotes = __webpack_require__(2);

Object.defineProperty(exports, 'footnotes', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_footnotes).default;
  }
});

var _nodes = __webpack_require__(8);

Object.defineProperty(exports, 'footnoteNodes', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_nodes).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _prosemirrorState = __webpack_require__(0);

var _FootnoteView = __webpack_require__(3);

var _FootnoteView2 = _interopRequireDefault(_FootnoteView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (options) {
  return new _prosemirrorState.Plugin({
    props: {
      nodeViews: {
        footnote: function footnote(node, view, getPos) {
          return new _FootnoteView2.default(node, view, getPos);
        }
      }
    }
  });
};

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _prosemirrorTransform = __webpack_require__(4);

var _prosemirrorKeymap = __webpack_require__(5);

var _prosemirrorHistory = __webpack_require__(6);

var _prosemirrorView = __webpack_require__(7);

var _prosemirrorState = __webpack_require__(0);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FootnoteView = function () {
  function FootnoteView(node, view, getPos) {
    _classCallCheck(this, FootnoteView);

    this.node = node;
    this.outerView = view;
    this.getPos = getPos;

    this.dom = document.createElement('prosemirror-footnote');
    this.innerView = null;
  }

  _createClass(FootnoteView, [{
    key: 'selectNode',
    value: function selectNode() {
      this.dom.classList.add('ProseMirror-selectednode');

      if (!this.innerView) {
        this.open();
      }
    }
  }, {
    key: 'deselectNode',
    value: function deselectNode() {
      this.dom.classList.remove('ProseMirror-selectednode');

      if (this.innerView) {
        this.close();
      }
    }
  }, {
    key: 'open',
    value: function open() {
      var _this = this;

      var tooltip = this.dom.appendChild(document.createElement('div'));
      tooltip.className = 'footnote-tooltip';

      this.innerView = new _prosemirrorView.EditorView(tooltip, {
        state: _prosemirrorState.EditorState.create({
          doc: this.node,
          plugins: [(0, _prosemirrorKeymap.keymap)({
            'Mod-z': function ModZ() {
              return (0, _prosemirrorHistory.undo)(_this.outerView.state, _this.outerView.dispatch);
            },
            'Mod-y': function ModY() {
              return (0, _prosemirrorHistory.redo)(_this.outerView.state, _this.outerView.dispatch);
            }
          })]
        }),
        dispatchTransaction: this.dispatchInner.bind(this),
        handleDOMEvents: {
          mousedown: function mousedown() {
            if (_this.outerView.hasFocus()) {
              _this.innerView.focus();
            }
          }
        }
      });

      this.innerView.focus();
    }
  }, {
    key: 'close',
    value: function close() {
      this.innerView.destroy();
      this.innerView = null;
      this.dom.textContent = '';
    }
  }, {
    key: 'dispatchInner',
    value: function dispatchInner(tr) {
      var _innerView$state$appl = this.innerView.state.applyTransaction(tr),
          state = _innerView$state$appl.state,
          transactions = _innerView$state$appl.transactions;

      this.innerView.updateState(state);

      if (!tr.getMeta('fromOutside')) {
        var outerTr = this.outerView.state.tr;
        var offsetMap = _prosemirrorTransform.StepMap.offset(this.getPos() + 1);

        transactions.forEach(function (transaction) {
          transaction.steps.forEach(function (step) {
            outerTr.step(step.map(offsetMap));
          });
        });

        if (outerTr.docChanged) {
          this.outerView.dispatch(outerTr);
        }
      }
    }
  }, {
    key: 'update',
    value: function update(node) {
      if (!node.sameMarkup(this.node)) {
        return false;
      }

      this.node = node;

      if (this.innerView) {
        var state = this.innerView.state;
        var start = node.content.findDiffStart(state.doc.content);

        if (start != null) {
          var _node$content$findDif = node.content.findDiffEnd(state.doc.content),
              endA = _node$content$findDif.a,
              endB = _node$content$findDif.b;

          var overlap = start - Math.min(endA, endB);

          if (overlap > 0) {
            endA += overlap;
            endB += overlap;
          }

          this.innerView.dispatch(state.tr.replace(start, endB, node.slice(start, endA)).setMeta('fromOutside', true));
        }
      }

      return true;
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      if (this.innerView) {
        this.close();
      }
    }
  }, {
    key: 'stopEvent',
    value: function stopEvent(event) {
      return this.innerView && this.innerView.dom.contains(event.target);
    }
  }, {
    key: 'ignoreMutation',
    value: function ignoreMutation() {
      return true;
    }
  }]);

  return FootnoteView;
}();

exports.default = FootnoteView;

/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = require("prosemirror-transform");

/***/ }),
/* 5 */
/***/ (function(module, exports) {

module.exports = require("prosemirror-keymap");

/***/ }),
/* 6 */
/***/ (function(module, exports) {

module.exports = require("prosemirror-history");

/***/ }),
/* 7 */
/***/ (function(module, exports) {

module.exports = require("prosemirror-view");

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  footnote: {
    group: 'inline',
    content: 'inline*',
    inline: true,
    draggable: true,
    atom: true,
    toDOM: function toDOM() {
      return ['prosemirror-footnote', 0];
    },
    parseDOM: [{ tag: 'prosemirror-footnote' }]
  }
};

/***/ })
/******/ ]);